module.exports = __webpack_public_path__ + "static/img/zszq.81534a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zszq.png
// module id = Himn
// module chunks = 3